

const Currency = () => {
    const retrievedCurrency = {
        Naira :  '₦',
        Dollar: "$",
        Yen : "¥",
        GBP: "£",
        Euros: "€",
    };
    return retrievedCurrency;
  };
  
  export default Currency;